// extracted by mini-css-extract-plugin
module.exports = {"replies":"tweet-replies_replies__qj6IC","link":"tweet-replies_link__RSbnZ","text":"tweet-replies_text__E_nff"};